
import React from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AboutUsCompo from "../components/AboutUsCompo";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";

const AboutUs = () => {
  return (

  <>
 <SEO
   title="About Us | EZ Car Rentals Melbourne - Your Trusted Vehicle Rental Partner"
   description="Learn about EZ Car Rentals, Melbourne's trusted car, van, and ute rental service. Serving Victoria, Australia with affordable, reliable vehicle hire solutions in Huntingdale and surrounding areas."
   keywords="about EZ Car Rentals, car rental company Melbourne, vehicle hire Victoria, EZ Car Rentals history, car rental service Australia, trusted car rental Melbourne"
   url="https://ezcarrentals.com.au/about-us"
 />
 <StructuredData type="organization" />
 <Navbar />
 <AboutUsCompo />
 <Footer />
 

 </>
  );
};

export default AboutUs;
